<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps({
  isLoading: Boolean,
  minHeight: Number,
});

const loaderStyles = computed(() =>
  props.minHeight
    ? {
        minHeight: `${props.minHeight}px`,
      }
    : {}
);
</script>

<template>
  <div class="loader-spinner overview-loader" :style="loaderStyles">
    <span class="icon-loader-icon" :class="{ spinner: isLoading }"></span>
  </div>
</template>

<style scoped>
.loader-spinner {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: inherit;
}
</style>
